import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

// Updated interface to handle array of data
interface StudyMaterialState extends Omit<IReduxState<any>, "data"> {
  data: any[]; // Array to store multiple study materials
}

export const StudyMaterialReadByIdSlice = createSlice({
  name: "StudyMaterialReadByIdSlice",
  initialState: {
    data: [],
    isLoading: false,
  } as StudyMaterialState,
  reducers: {
    StudyMaterialReadById: (state, _) => {
      state.isLoading = true;
    },
    successStudyMaterialReadById: (state, action: PayloadAction<any>) => {
      // Check if the item already exists (optional - to prevent duplicates)
      const existingIndex = state.data.findIndex(
        (item) => item.id === action.payload.id
      );

      if (existingIndex !== -1) {
        // Update existing item
        state.data[existingIndex] = action.payload;
      } else {
        // Add new item to array
        state.data.push(action.payload);
      }

      state.isLoading = false;
    },
    failureStudyMaterialReadById: (state, action: PayloadAction<any>) => {
      // You might want to handle errors differently
      // For now, keeping the existing data and just setting loading to false
      state.data.push(action.payload);
      state.isLoading = false;
    },
    clearStudyMaterialReadById: (state) => {
      state.data = [];
      state.isLoading = false;
    },
    // Optional: Add reducer to remove specific item by ID
    removeStudyMaterialById: (
      state,
      action: PayloadAction<string | number>
    ) => {
      state.data = state.data.filter((item) => item.id !== action.payload);
    },
  },
});

export const {
  StudyMaterialReadById,
  successStudyMaterialReadById,
  failureStudyMaterialReadById,
  clearStudyMaterialReadById,
  removeStudyMaterialById, // Export the new action
} = StudyMaterialReadByIdSlice.actions;

export default StudyMaterialReadByIdSlice.reducer;
